export default "__VITE_ASSET__8053f0b4__"